import axios from 'src/utils/axios';
import { endpoints } from 'src/utils/api-endpoints';

// ----------------------------------------------------------------------

interface SearchResult {
  title: string;
  path: string;
  category: string;
}

export async function search(query: string, organizationId: string): Promise<SearchResult[]> {
  const url = endpoints.search.search(organizationId); 

  try {
    const response = await axios.get<SearchResult[]>(url, {
      params: { query },
    });
    if (Array.isArray(response.data)) {
      return response.data;
    } else {
      console.error('Unexpected response structure:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error during search:', error);
    return [];
  }
}
